import styled from 'styled-components/macro';
import { hexToRgb } from '../../Utils/utils';
import { Input, InputLabel, StyledInput } from '../../SubComponents/Inputs';
import { colors } from '../../Style/Theme';
import { ThemeName } from '../../Style/types';

export const PhoneNumberInput = styled(Input)`
  flex: 1 1;
  position: ${(props: any) => (Boolean(props.value) ? 'static' : 'relative')};

  ${StyledInput} {
    background: transparent;
    border: none;
    box-shadow: none;
    width: 100%;

    &[data-focus-visible-added] {
      outline: none;
    }
  }

  ${InputLabel} {
    left: ${(props: any) =>
      props.matchStripeAppearance ? '0px' : Boolean(props.value) ? '4px' : '13px'};
  }
`;

export const PhoneInputContainer = styled.div<{ error: boolean; disabled: boolean }>`
  position: relative;
  margin: 32px 0 0 25px;
  flex: 1 1 calc(50% - 25px);
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? hexToRgb(props.theme.inputBackgroundColor, { opacity: 35 })
      : props.theme.inputBackgroundColor};
  border-radius: ${(props) => props.theme.inputs.borderRadius};
  height: 35px;
  box-shadow: ${(props) =>
    props.error
      ? `0px 0px 0px 1px ${props.theme.errorColor}`
      : props.disabled
      ? `0px 0px 0px 1px ${hexToRgb(props.theme.inputBorderColor, { opacity: 35 })}`
      : `0px 0px 0px 1px ${props.theme.inputBorderColor}`};
  transition: all ease-in-out 0.15s;

  :focus-within {
    outline: none;
    box-shadow: ${(props) =>
      props.error
        ? `0px 0px 0px 1px ${props.theme.errorColor}, 0px 0px 0px 4px ${hexToRgb(
            props.theme.errorColor,
            { opacity: 25 }
          )}`
        : `0px 0px 0px 1px ${
            props.theme.inputBorderColorFocus
          }, 0px 0px 0px 4px ${hexToRgb(props.theme.inputBorderColorFocus, {
            opacity: 25,
          })}}`};
  }

  @media screen and (max-width: 767px) {
    flex: 0 0 calc(100% - 25px);
  }

  @media screen and (min-width: 768px) {
    max-width: calc(50% - 25px);
  }
`;

export const CustomSelect = styled.div`
  position: relative;
  margin-right: 12px;
`;

export const CustomSelectButton = styled.button<{ error: boolean; disabled: boolean }>`
  position: relative;
  background: transparent;
  border: none;
  font-size: 1.6rem;
  color: ${(props) => props.theme.textColor};
  padding: 5px 34px 4px 12px;

  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: ${(props) => props.theme.inputBorderColor};
  border-radius: ${(props) => props.theme.inputs.borderRadius} 0 0
    ${(props) => props.theme.inputs.borderRadius};

  :disabled {
    opacity: 0.35;
  }

  :focus-visible {
    border-color: transparent;
    background-color: ${colors.lightBlue};
    outline: none;
    box-shadow: ${(props) =>
      props.error
        ? `0px 0px 0px 1px ${props.theme.errorColor}`
        : `0px 0px 0px 1px ${props.theme.inputBorderColorFocus}`};
  }
`;

export const CustomSelectOptions = styled.ul`
  position: absolute;
  top: 47px;
  list-style: none;
  max-height: 300px;
  overflow: auto;
  width: max-content;
  font-family: ${(props) => props.theme.fontText};
  font-size: 1.4rem;
  color: ${(props) => props.theme.textColor};
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: default;
  z-index: 200;

  :focus-visible {
    outline: none;
    box-shadow: ${(props) =>
      `0px 0px 0px 1px ${props.theme.inputBorderColorFocus}, 0px 0px 0px 4px ${hexToRgb(
        props.theme.inputBorderColorFocus,
        { opacity: 25 }
      )}}`};
  }

  @media screen and (max-width: 767px) {
    max-height: 200px;
    max-width: calc(90vw - 10px);
  }
`;

export const CustomSelectOption = styled.li`
  padding: 4px 16px;
  cursor: default;

  &&[data-headlessui-state~='active'] {
    background-color: ${colors.lightBlue};
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${(props) =>
    props.theme.name === ThemeName.Starboard ? 'center' : 'flex-end'};
`;
